import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  EVALUATION_DETAIL_LIST,
  EVALUATION_DETAIL_SEARCH_EVALUATION,
  EVALUATION_DETAIL_SEARCH_DOCUMENT,
  EVALUATION_DETAIL_SEARCH_ANSWER,
  EVALUATION_DETAIL_ADD,
  EVALUATION_DETAIL_DETAIL,
  EVALUATION_DETAIL_UPDATE
} from '../../actions';

import {
  EvaluationDetailListSuccess,
  EvaluationDetailListError,
  EvaluationDetailSearchEvaluationSuccess,
  EvaluationDetailSearchEvaluationError,
  EvaluationDetailSearchDocumentSuccess,
  EvaluationDetailSearchDocumentError,
  EvaluationDetailSearchAnswerSuccess,
  EvaluationDetailSearchAnswerError,
  EvaluationDetailAddSuccess,
  EvaluationDetailAddError,
  EvaluationDetailDetailSuccess,
  EvaluationDetailDetailError,
  EvaluationDetailUpdateSuccess,
  EvaluationDetailUpdateError
} from '../../actions';
 
export function* watchEvaluationDetailList() {
  yield takeEvery(EVALUATION_DETAIL_LIST, onEvaluationDetailList);
}

export function* watchEvaluationDetailSearchEvaluation() {
  yield takeEvery(EVALUATION_DETAIL_SEARCH_EVALUATION, onEvaluationDetailSearchEvaluation);
}

export function* watchEvaluationDetailSearchDocument() {
  yield takeEvery(EVALUATION_DETAIL_SEARCH_DOCUMENT, onEvaluationDetailSearchDocument);
}

export function* watchEvaluationDetailSearchAnswer() {
  yield takeEvery(EVALUATION_DETAIL_SEARCH_ANSWER, onEvaluationDetailSearchAnswer);
}

export function* watchEvaluationDetailAdd() {
  yield takeEvery(EVALUATION_DETAIL_ADD, onEvaluationDetailAdd);
}

export function* watchEvaluationDetailDetail() {
  yield takeEvery(EVALUATION_DETAIL_DETAIL, onEvaluationDetailDetail);
}

export function* watchEvaluationDetailUpdate() {
  yield takeEvery(EVALUATION_DETAIL_UPDATE, onEvaluationDetailUpdate);
}

const onEvaluationDetailListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'evaluation_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationDetailUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'evaluation_detail/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationDetailSearchEvaluationAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/evaluation', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationDetailSearchDocumentAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/document', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationDetailSearchAnswerAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/answer', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationDetailAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'evaluation_detail/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationDetailDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'evaluation_detail/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onEvaluationDetailList(data) {
  try {
    const response = yield call(onEvaluationDetailListAsync, data.payload);
    yield put(EvaluationDetailListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationDetailListError(error));
  }
}

function* onEvaluationDetailSearchEvaluation(data) {
  try {
    const response = yield call(onEvaluationDetailSearchEvaluationAsync, data.payload);
    yield put(EvaluationDetailSearchEvaluationSuccess(response.data));
  } catch (error) {
    yield put(EvaluationDetailSearchEvaluationError(error));
  }
}

function* onEvaluationDetailSearchDocument(data) {
  try {
    const response = yield call(onEvaluationDetailSearchDocumentAsync, data.payload);
    yield put(EvaluationDetailSearchDocumentSuccess(response.data));
  } catch (error) {
    yield put(EvaluationDetailSearchDocumentError(error));
  }
}

function* onEvaluationDetailSearchAnswer(data) {
  try {
    const response = yield call(onEvaluationDetailSearchAnswerAsync, data.payload);
    yield put(EvaluationDetailSearchAnswerSuccess(response.data));
  } catch (error) {
    yield put(EvaluationDetailSearchAnswerError(error));
  }
}

function* onEvaluationDetailAdd(data) {
  try {
      const response = yield call(onEvaluationDetailAddAsync, data);
      yield put(EvaluationDetailAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationDetailAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationDetailDetail(data) {
  try {
    const response = yield call(onEvaluationDetailDetailAsync, data.payload);
    yield put(EvaluationDetailDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationDetailDetailError(error));
  }
}

function* onEvaluationDetailUpdate(data) {
  try {
      const response = yield call(onEvaluationDetailUpdateAsync, data.payload);
      yield put(EvaluationDetailUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationDetailUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationDetailList),
    fork(watchEvaluationDetailSearchEvaluation),
    fork(watchEvaluationDetailSearchDocument),
    fork(watchEvaluationDetailSearchAnswer),
    fork(watchEvaluationDetailAdd),
    fork(watchEvaluationDetailDetail),
    fork(watchEvaluationDetailUpdate),
  ]);
} 